export type MediaType = {
  video: boolean;
  image: boolean;
};

type VideExtensions = 'mp4' | 'webm' | 'ogg' | 'ogv' | 'mov' | 'avi';
type ImageExtensions = 'jpeg' | 'jpg' | 'png' | 'gif' | 'webp' | 'svg';
type FileNameWithExtension<Ext extends string> = `${string}.${Ext}`;
type FileName = FileNameWithExtension<ImageExtensions> | FileNameWithExtension<VideExtensions>;

const getMediaTypeInternal = (filename: string | undefined): MediaType => {
  filename = filename?.split('?')[0];
  if (!filename) {
    return { video: false, image: false } as const;
  }
  return {
    video: isVideo(filename),
    image: isImage(filename),
  } as const;
};

export const isVideo = (filename: string): boolean =>
  /\.(mp4|webm|ogg|ogv|mov|avi)$/i.test(filename);
export const isImage = (filename: string): boolean =>
  /\.(jpeg|jpg|png|gif|webp|svg)$/i.test(filename);

/**
 *
 * @param filename Media file name
 * @returns MediaType object with video and image boolean values based on file name extension
 */
export const getMediaType = (filename: string | undefined): MediaType =>
  getMediaTypeInternal(filename);

/**
 *
 * @param filename Media file name (will be checked at compile time)
 * @returns MediaType object with video and image boolean values based on file name extension
 */
export const getMediaTypeWithFileNameCompileTimeCheck = <T extends FileName>(
  filename: T,
): MediaType => getMediaTypeInternal(filename);
